import AdminBottomNavbar from "./bottom-navbar";

export { AdminBottomNavbar };
